import { render, staticRenderFns } from "./blocks.vue?vue&type=template&id=4ea5c1e3&scoped=true&"
import script from "./blocks.vue?vue&type=script&lang=js&"
export * from "./blocks.vue?vue&type=script&lang=js&"
import style0 from "./blocks.vue?vue&type=style&index=0&id=4ea5c1e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea5c1e3",
  null
  
)

export default component.exports